module.exports = __webpack_public_path__ + "img/header-icon5.e7181bc8.jpg";